// @ts-nocheck

import React, { useState, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Controller, FieldValues, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import ReactStars from 'react-rating-stars-component'
import moment from 'moment'
import 'moment-timezone'
import { Desktop, Mobile } from 'Shared/components/Responsive'
import ava from 'Shared/img/ava.png'
import TextAreaInput from 'Components/TextAreaInput'
import { VideoStatus } from 'Constants/enums'
import { colors } from 'Styled/variables'
import { calcTimeLeft } from 'Containers/Tracks/helpers'

import { IconTikTok } from 'Stories/Icon/Icon.stories'
import {
  putTiktokCampaignRate,
  postTiktokCampaignReject,
} from 'Redux/actions/campaignActions'
import { formatDate } from 'Constants/formatDate'
import { WhiteGreenBtn, WhiteGreyBtn } from 'Stories/Button/Button.stories'

import SelectResponseRatingComponent from '../../../CampaignResults/components/SelectResponseRating'
import {
  BtnContainer,
  BtnsRateWrappper,
  BtnsWrappper,
  BtnWrappper,
  Card,
  Divider,
  Followers,
  Minutes,
  PersonalInfo,
  Profile,
  RejectWrapper,
  Stars,
  Status,
  StyledBlock,
  StyledBtn,
  StyledCancel,
  StyledImg,
  StyledLink,
  StyledName,
  StyledTitle,
  SubTitle,
  TopBar,
  VideoInfo,
} from './styles'

export interface RateVideoValues {
  textareaRateValue: string
  rateValue: number
}
const VideoCard = ({ card }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [textareaRejectState, setTextareaRejectFieldState] = useState(false)
  const [textareaRejectValue, setTextareaRejectValue] = useState('')
  const [textareaRateValue, setTextareaRateValue] = useState('')
  const [rateValue, setRateValue] = useState<number>(0)
  const [rateAnswer, setRateAnswer] = useState<boolean>(false)

  const handleTextField = () => {
    setTextareaRejectFieldState(!textareaRejectState)
  }

  const handleReject = () => {
    dispatch(postTiktokCampaignReject(card.id, textareaRejectValue))
    handleTextField()
  }

  const handleRate = (values: RateVideoValues) => {
    dispatch(
      putTiktokCampaignRate(
        card.id,
        textareaRateValue,
        rateValue,
        (error, payload) => {
          if (!error) {
            setRateAnswer(true)
          }
        }
      )
    )
  }

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const startDate = moment.tz(card.createdAt, timezone)
  const endDateTz = useMemo(() => startDate.add(120, 'minutes'), [startDate])
  const formattedDate = endDateTz.format(formatDate.formatDateWithTime)
  const minutesLeft = Math.max(
    endDateTz.diff(moment.tz(timezone), 'minutes'),
    0
  )

  const setStatus = stat => {
    switch (stat) {
      case VideoStatus.ACCEPTED:
        return t('campaignResultsPage.awaiting')

      case VideoStatus.AWAITING_REVIEW:
      case VideoStatus.AWAITING_MODERATOR_REVIEW:
        return t('campaignResultsPage.published')

      case VideoStatus.APPROVED_BY_ARTIST:
        return t('campaignResultsPage.reviewed2')

      case VideoStatus.CANCELED:
      case VideoStatus.CANCELED_BY_ARTIST:
      case VideoStatus.DECLINED:
        return t('campaignResultsPage.rejected')

      case VideoStatus.APPROVED_AUTOMATICALLY:
        return t('campaignResultsPage.cronApprove')

      case VideoStatus.APPROVED_BY_ADMIN:
        return t('campaignResultsPage.adminReview')

      default:
        return null
    }
  }

  return (
    <Card>
      <PersonalInfo>
        <StyledImg alt="avatar" height={40} src={card.avatar || ava} />

        <StyledBlock>
          <StyledName>
            {card.nickname.substr(0, 1).toUpperCase() +
              card.nickname.substr(1).toLowerCase()}
          </StyledName>
          <Stars>
            <ReactStars
              count={5}
              edit={false}
              value={card.rate}
              size={12}
              color={colors.greyTextBlackBg}
              activeColor={colors.messegesYellow1}
            />
          </Stars>
          <Followers>
            {card.followerCount.toLocaleString('en')}&nbsp;
            {t('campaignResultsPage.amountOfFollowers')}
          </Followers>
          <Profile
            href={card?.videoLink?.split('/', 4).join('/')}
            target="_blank"
            rel="noopener"
          >
            {t('campaignResultsPage.tikTokProfile')}
          </Profile>
        </StyledBlock>
      </PersonalInfo>

      <Divider />

      <VideoInfo textareaRejectState={textareaRejectState}>
        <TopBar>
          <div>
            <StyledTitle>{t('campaignResultsPage.status')}</StyledTitle>
            <Status status={card.status}>{setStatus(card.status)}</Status>
          </div>
          <div>
            {card.status === VideoStatus.ACCEPTED ||
            card.status === VideoStatus.AWAITING_REVIEW ||
            card.status === VideoStatus.AWAITING_MODERATOR_REVIEW ? (
              <StyledTitle>{t('campaignResultsPage.deadline')}</StyledTitle>
            ) : (
              <StyledTitle>{t('campaignResultsPage.reviewDate')}</StyledTitle>
            )}
            <div>{formattedDate}</div>
          </div>
          <BtnWrappper>
            {(card.status === VideoStatus.AWAITING_REVIEW ||
              card.status === VideoStatus.AWAITING_MODERATOR_REVIEW ||
              card.status === VideoStatus.APPROVED_AUTOMATICALLY ||
              card.status === VideoStatus.APPROVED_BY_ADMIN ||
              card.status === VideoStatus.APPROVED_BY_ARTIST) && (
              <WhiteGreenBtn color="whiteGreen">
                <BtnContainer>
                  <IconTikTok />
                  <StyledLink
                    href={card.videoLink}
                    target="_blank"
                    rel="noopener"
                  >
                    {t('campaignResultsPage.videoOnTiktok')}
                  </StyledLink>
                </BtnContainer>
              </WhiteGreenBtn>
            )}
          </BtnWrappper>
        </TopBar>

        {card.status === VideoStatus.ACCEPTED && (
          <>
            {!textareaRejectState && (
              <div>
                <StyledBtn onClick={handleTextField}>
                  {t('campaignResultsPage.rejectCreator')}
                </StyledBtn>
                <Minutes>
                  {/* TODO need to clarify */}
                  {minutesLeft.toFixed()}
                  &nbsp;{t('campaignResultsPage.minutesLeft')}
                </Minutes>
              </div>
            )}
            {textareaRejectState && (
              <RejectWrapper>
                <SubTitle>
                  {t('campaignResultsPage.pleaseIndicateTheReasonForRejecting')}
                </SubTitle>
                <TextAreaInput
                  value={textareaRejectValue}
                  placeholder={t('campaignResultsPage.reasonRejection')}
                  onChange={e => setTextareaRejectValue(e.target.value)}
                />
                <BtnsWrappper>
                  <StyledCancel onClick={handleTextField}>
                    <Desktop>{t('campaignResultsPage.cancel')}</Desktop>
                    <Mobile>
                      {t('campaignResultsPage.pleaseRateYourVideo')}
                    </Mobile>
                  </StyledCancel>
                  {!textareaRejectValue ? (
                    <WhiteGreyBtn disabled color="greyBorderDisabled">
                      {t('campaignResultsPage.confirm')}
                    </WhiteGreyBtn>
                  ) : (
                    <WhiteGreenBtn color="whiteGreen" onClick={handleReject}>
                      {t('campaignResultsPage.confirm')}
                    </WhiteGreenBtn>
                  )}
                </BtnsWrappper>
              </RejectWrapper>
            )}
          </>
        )}

        {(card.status === VideoStatus.AWAITING_REVIEW ||
          card.status === VideoStatus.AWAITING_MODERATOR_REVIEW) && (
          <>
            {rateAnswer && (
              <div>
                <SubTitle>
                  {t('campaignResultsPage.pleaseRateYourVideo')}
                </SubTitle>
                <TextAreaInput
                  value={textareaRateValue}
                  placeholder={t('campaignResultsPage.letUsKnowHowDoYouLikeIt')}
                  onChange={e => setTextareaRateValue(e.target.value)}
                />

                <BtnsRateWrappper>
                  <SelectResponseRatingComponent
                    value={rateValue}
                    onChange={rate => setRateValue(rate)}
                  />

                  {!textareaRateValue ? (
                    <WhiteGreyBtn disabled color="greyBorderDisabled">
                      {t('campaignResultsPage.send')}
                    </WhiteGreyBtn>
                  ) : (
                    <WhiteGreenBtn color="whiteGreen" onClick={handleRate}>
                      {t('campaignResultsPage.send')}
                    </WhiteGreenBtn>
                  )}
                </BtnsRateWrappper>
              </div>
            )}
          </>
        )}

        {[
          VideoStatus.APPROVED_AUTOMATICALLY,
          VideoStatus.APPROVED_BY_ARTIST,
          VideoStatus.APPROVED_BY_ADMIN,
        ].includes(card.status) && (
          <div>
            <StyledTitle>{t('campaignResultsPage.yourRespond')}</StyledTitle>

            <Stars>
              <ReactStars
                count={5}
                edit={false}
                value={card.rate}
                size={12}
                color={colors.greyTextBlackBg}
                activeColor={colors.messegesYellow1}
              />
            </Stars>

            <StyledTitle>{t('campaignResultsPage.review')}</StyledTitle>
            <SubTitle>{card.feedback}</SubTitle>
          </div>
        )}
      </VideoInfo>
    </Card>
  )
}
export default VideoCard
